import { BOOKING_PLUGIN_URL } from './DaySmartAppointmentBooking.constants';
export function getDaySmartBookingURL(guid) {
  return "".concat(BOOKING_PLUGIN_URL, "?guid=").concat(guid);
}